import React from 'react';
import { Link } from 'react-router-dom';
import Count from '../../common/count';
import image from "../../../assets/img/page/skill.jpg";

const Advices = () => {
    return (
        <div className="success__area">
        </div>
    );
};

export default Advices;